import apiSlice from "../api/apiSlice";
import { setInitialChecked } from "../filter/filterSlice";

const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: () => "/projects",

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: projects } = await queryFulfilled;

          const checked = projects.map(({ projectName }) => projectName);
          dispatch(setInitialChecked(checked));
        } catch (error) {
          console.log(error);
        }
      },
    }),
  }),
});

export const { useGetProjectsQuery } = projectsApi;
export default projectsApi;
